import axios from "axios";

declare const PRODUCTION;

interface ISettings {
  geoServerUrl: string
  geoServerCredentialCheckUrl: string
  product: { title: string, description: string, metadata: string, tableDates: string }
  wmsLayers: layer.config[]
  wpsPlugin: {
    serviceUrl: string,
    xmlConfig: string
  }
}


// You can customize settings below :)
const settings: ISettings = {
  geoServerUrl: 'https://geoserver.esairide.tddev.it/geoserver',
  geoServerCredentialCheckUrl: `https://geoserver.esairide.tddev.it/geoserver/ESAPALWS/wms?service=WMS&version=1.3.0&request=GetCapabilities`,
  product: {
    title: "SWF — Small Woody Features",
    description: "Small Woody Features (SWF) — vector mapping of small woody features across 11 Italian regions (Campania, Friuli Venezia Giulia, Lazio, Liguria, Lombardia, Marche, Puglia, Toscana, Umbria, Valle d'Aosta, Veneto) with reference years from 2023 to 2025. Every layer distinguishes three classes: 1 = linear, 2 = patchy, 3 = riparian. Attributes include the surface area (area_mq), the region and province, and the Sentinel-2 tile. The statistics panel aggregates the features of the layer currently visible in the map extent.",
    tableDates: "<table class='table-dates'><tr><th>Region</th><th class='right'>Layers</th><th class='right'>Years</th></tr><tr><td>Campania</td><td class='right'>10</td><td class='right'>2024/2025</td></tr><tr><td>Friuli Venezia Giulia</td><td class='right'>4</td><td class='right'>2025</td></tr><tr><td>Lazio</td><td class='right'>1</td><td class='right'>2025</td></tr><tr><td>Liguria</td><td class='right'>12</td><td class='right'>2023/2024/2025</td></tr><tr><td>Lombardia</td><td class='right'>12</td><td class='right'>2025</td></tr><tr><td>Marche</td><td class='right'>8</td><td class='right'>2024/2025</td></tr><tr><td>Puglia</td><td class='right'>3</td><td class='right'>2023/2024/2025</td></tr><tr><td>Toscana</td><td class='right'>30</td><td class='right'>2023/2024/2025</td></tr><tr><td>Umbria</td><td class='right'>6</td><td class='right'>2023/2024/2025</td></tr><tr><td>Valle d'Aosta</td><td class='right'>1</td><td class='right'>2025</td></tr><tr><td>Veneto</td><td class='right'>14</td><td class='right'>2024/2025</td></tr></table>",
    metadata: ""
  },
  wmsLayers: [
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Avellino_2024",
      version: "1.3.0",
      metadata: {
        title: "Campania · Avellino · 2024",
        description: "Small Woody Features (SWF) — Campania, Avellino, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Avellino_2025",
      version: "1.3.0",
      metadata: {
        title: "Campania · Avellino · 2025",
        description: "Small Woody Features (SWF) — Campania, Avellino, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Benevento_2024",
      version: "1.3.0",
      metadata: {
        title: "Campania · Benevento · 2024",
        description: "Small Woody Features (SWF) — Campania, Benevento, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Benevento_2025",
      version: "1.3.0",
      metadata: {
        title: "Campania · Benevento · 2025",
        description: "Small Woody Features (SWF) — Campania, Benevento, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Caserta_2024",
      version: "1.3.0",
      metadata: {
        title: "Campania · Caserta · 2024",
        description: "Small Woody Features (SWF) — Campania, Caserta, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Caserta_2025",
      version: "1.3.0",
      metadata: {
        title: "Campania · Caserta · 2025",
        description: "Small Woody Features (SWF) — Campania, Caserta, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Napoli_2024",
      version: "1.3.0",
      metadata: {
        title: "Campania · Napoli · 2024",
        description: "Small Woody Features (SWF) — Campania, Napoli, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Napoli_2025",
      version: "1.3.0",
      metadata: {
        title: "Campania · Napoli · 2025",
        description: "Small Woody Features (SWF) — Campania, Napoli, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Salerno_2024",
      version: "1.3.0",
      metadata: {
        title: "Campania · Salerno · 2024",
        description: "Small Woody Features (SWF) — Campania, Salerno, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Campania_Salerno_2025",
      version: "1.3.0",
      metadata: {
        title: "Campania · Salerno · 2025",
        description: "Small Woody Features (SWF) — Campania, Salerno, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Friuli_Venezia_Giulia_Gorizia_2025",
      version: "1.3.0",
      metadata: {
        title: "Friuli Venezia Giulia · Gorizia · 2025",
        description: "Small Woody Features (SWF) — Friuli Venezia Giulia, Gorizia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Friuli_Venezia_Giulia_Pordenone_2025",
      version: "1.3.0",
      metadata: {
        title: "Friuli Venezia Giulia · Pordenone · 2025",
        description: "Small Woody Features (SWF) — Friuli Venezia Giulia, Pordenone, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Friuli_Venezia_Giulia_Trieste_2025",
      version: "1.3.0",
      metadata: {
        title: "Friuli Venezia Giulia · Trieste · 2025",
        description: "Small Woody Features (SWF) — Friuli Venezia Giulia, Trieste, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Friuli_Venezia_Giulia_Udine_2025",
      version: "1.3.0",
      metadata: {
        title: "Friuli Venezia Giulia · Udine · 2025",
        description: "Small Woody Features (SWF) — Friuli Venezia Giulia, Udine, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lazio_Roma_2025",
      version: "1.3.0",
      metadata: {
        title: "Lazio · Roma · 2025",
        description: "Small Woody Features (SWF) — Lazio, Roma, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Genova_2023",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Genova · 2023",
        description: "Small Woody Features (SWF) — Liguria, Genova, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Genova_2024",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Genova · 2024",
        description: "Small Woody Features (SWF) — Liguria, Genova, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Genova_2025",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Genova · 2025",
        description: "Small Woody Features (SWF) — Liguria, Genova, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Imperia_2023",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Imperia · 2023",
        description: "Small Woody Features (SWF) — Liguria, Imperia, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Imperia_2024",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Imperia · 2024",
        description: "Small Woody Features (SWF) — Liguria, Imperia, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Imperia_2025",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Imperia · 2025",
        description: "Small Woody Features (SWF) — Liguria, Imperia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_La_Spezia_2023",
      version: "1.3.0",
      metadata: {
        title: "Liguria · La Spezia · 2023",
        description: "Small Woody Features (SWF) — Liguria, La Spezia, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_La_Spezia_2024",
      version: "1.3.0",
      metadata: {
        title: "Liguria · La Spezia · 2024",
        description: "Small Woody Features (SWF) — Liguria, La Spezia, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_La_Spezia_2025",
      version: "1.3.0",
      metadata: {
        title: "Liguria · La Spezia · 2025",
        description: "Small Woody Features (SWF) — Liguria, La Spezia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Savona_2023",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Savona · 2023",
        description: "Small Woody Features (SWF) — Liguria, Savona, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Savona_2024",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Savona · 2024",
        description: "Small Woody Features (SWF) — Liguria, Savona, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Liguria_Savona_2025",
      version: "1.3.0",
      metadata: {
        title: "Liguria · Savona · 2025",
        description: "Small Woody Features (SWF) — Liguria, Savona, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Bergamo_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Bergamo · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Bergamo, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Brescia_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Brescia · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Brescia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Como_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Como · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Como, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Cremona_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Cremona · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Cremona, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Lecco_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Lecco · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Lecco, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Lodi_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Lodi · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Lodi, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Mantova_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Mantova · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Mantova, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Milano_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Milano · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Milano, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Monza_e_della_Brianza_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Monza e della Brianza · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Monza e della Brianza, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Pavia_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Pavia · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Pavia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Sondrio_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Sondrio · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Sondrio, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Lombardia_Varese_2025",
      version: "1.3.0",
      metadata: {
        title: "Lombardia · Varese · 2025",
        description: "Small Woody Features (SWF) — Lombardia, Varese, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Ancona_2025",
      version: "1.3.0",
      metadata: {
        title: "Marche · Ancona · 2025",
        description: "Small Woody Features (SWF) — Marche, Ancona, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Ascoli_Piceno_2024",
      version: "1.3.0",
      metadata: {
        title: "Marche · Ascoli Piceno · 2024",
        description: "Small Woody Features (SWF) — Marche, Ascoli Piceno, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Ascoli_Piceno_2025",
      version: "1.3.0",
      metadata: {
        title: "Marche · Ascoli Piceno · 2025",
        description: "Small Woody Features (SWF) — Marche, Ascoli Piceno, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Fermo_2025",
      version: "1.3.0",
      metadata: {
        title: "Marche · Fermo · 2025",
        description: "Small Woody Features (SWF) — Marche, Fermo, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Macerata_2024",
      version: "1.3.0",
      metadata: {
        title: "Marche · Macerata · 2024",
        description: "Small Woody Features (SWF) — Marche, Macerata, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Macerata_2025",
      version: "1.3.0",
      metadata: {
        title: "Marche · Macerata · 2025",
        description: "Small Woody Features (SWF) — Marche, Macerata, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Pesaro_e_Urbino_2024",
      version: "1.3.0",
      metadata: {
        title: "Marche · Pesaro e Urbino · 2024",
        description: "Small Woody Features (SWF) — Marche, Pesaro e Urbino, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Marche_Pesaro_e_Urbino_2025",
      version: "1.3.0",
      metadata: {
        title: "Marche · Pesaro e Urbino · 2025",
        description: "Small Woody Features (SWF) — Marche, Pesaro e Urbino, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Puglia_Bari_2023",
      version: "1.3.0",
      metadata: {
        title: "Puglia · Bari · 2023",
        description: "Small Woody Features (SWF) — Puglia, Bari, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Puglia_Bari_2024",
      version: "1.3.0",
      metadata: {
        title: "Puglia · Bari · 2024",
        description: "Small Woody Features (SWF) — Puglia, Bari, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Puglia_Bari_2025",
      version: "1.3.0",
      metadata: {
        title: "Puglia · Bari · 2025",
        description: "Small Woody Features (SWF) — Puglia, Bari, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Arezzo_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Arezzo · 2023",
        description: "Small Woody Features (SWF) — Toscana, Arezzo, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Arezzo_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Arezzo · 2024",
        description: "Small Woody Features (SWF) — Toscana, Arezzo, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Arezzo_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Arezzo · 2025",
        description: "Small Woody Features (SWF) — Toscana, Arezzo, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Firenze_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Firenze · 2023",
        description: "Small Woody Features (SWF) — Toscana, Firenze, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Firenze_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Firenze · 2024",
        description: "Small Woody Features (SWF) — Toscana, Firenze, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Firenze_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Firenze · 2025",
        description: "Small Woody Features (SWF) — Toscana, Firenze, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Grosseto_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Grosseto · 2023",
        description: "Small Woody Features (SWF) — Toscana, Grosseto, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Grosseto_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Grosseto · 2024",
        description: "Small Woody Features (SWF) — Toscana, Grosseto, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Grosseto_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Grosseto · 2025",
        description: "Small Woody Features (SWF) — Toscana, Grosseto, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Livorno_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Livorno · 2023",
        description: "Small Woody Features (SWF) — Toscana, Livorno, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Livorno_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Livorno · 2024",
        description: "Small Woody Features (SWF) — Toscana, Livorno, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Livorno_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Livorno · 2025",
        description: "Small Woody Features (SWF) — Toscana, Livorno, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Lucca_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Lucca · 2023",
        description: "Small Woody Features (SWF) — Toscana, Lucca, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Lucca_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Lucca · 2024",
        description: "Small Woody Features (SWF) — Toscana, Lucca, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Lucca_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Lucca · 2025",
        description: "Small Woody Features (SWF) — Toscana, Lucca, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Massa_Carrara_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Massa Carrara · 2023",
        description: "Small Woody Features (SWF) — Toscana, Massa Carrara, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Massa_Carrara_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Massa Carrara · 2024",
        description: "Small Woody Features (SWF) — Toscana, Massa Carrara, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Massa_Carrara_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Massa Carrara · 2025",
        description: "Small Woody Features (SWF) — Toscana, Massa Carrara, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pisa_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pisa · 2023",
        description: "Small Woody Features (SWF) — Toscana, Pisa, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pisa_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pisa · 2024",
        description: "Small Woody Features (SWF) — Toscana, Pisa, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pisa_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pisa · 2025",
        description: "Small Woody Features (SWF) — Toscana, Pisa, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pistoia_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pistoia · 2023",
        description: "Small Woody Features (SWF) — Toscana, Pistoia, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pistoia_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pistoia · 2024",
        description: "Small Woody Features (SWF) — Toscana, Pistoia, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Pistoia_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Pistoia · 2025",
        description: "Small Woody Features (SWF) — Toscana, Pistoia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Prato_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Prato · 2023",
        description: "Small Woody Features (SWF) — Toscana, Prato, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Prato_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Prato · 2024",
        description: "Small Woody Features (SWF) — Toscana, Prato, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Prato_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Prato · 2025",
        description: "Small Woody Features (SWF) — Toscana, Prato, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Siena_2023",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Siena · 2023",
        description: "Small Woody Features (SWF) — Toscana, Siena, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Siena_2024",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Siena · 2024",
        description: "Small Woody Features (SWF) — Toscana, Siena, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Toscana_Siena_2025",
      version: "1.3.0",
      metadata: {
        title: "Toscana · Siena · 2025",
        description: "Small Woody Features (SWF) — Toscana, Siena, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Perugia_2023",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Perugia · 2023",
        description: "Small Woody Features (SWF) — Umbria, Perugia, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Perugia_2024",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Perugia · 2024",
        description: "Small Woody Features (SWF) — Umbria, Perugia, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Perugia_2025",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Perugia · 2025",
        description: "Small Woody Features (SWF) — Umbria, Perugia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Terni_2023",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Terni · 2023",
        description: "Small Woody Features (SWF) — Umbria, Terni, year 2023. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Terni_2024",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Terni · 2024",
        description: "Small Woody Features (SWF) — Umbria, Terni, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Umbria_Terni_2025",
      version: "1.3.0",
      metadata: {
        title: "Umbria · Terni · 2025",
        description: "Small Woody Features (SWF) — Umbria, Terni, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Valle_D_Aosta_Aosta_2025",
      version: "1.3.0",
      metadata: {
        title: "Valle d'Aosta · Aosta · 2025",
        description: "Small Woody Features (SWF) — Valle d'Aosta, Aosta, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Belluno_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Belluno · 2024",
        description: "Small Woody Features (SWF) — Veneto, Belluno, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Belluno_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Belluno · 2025",
        description: "Small Woody Features (SWF) — Veneto, Belluno, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Padova_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Padova · 2024",
        description: "Small Woody Features (SWF) — Veneto, Padova, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Padova_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Padova · 2025",
        description: "Small Woody Features (SWF) — Veneto, Padova, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Rovigo_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Rovigo · 2024",
        description: "Small Woody Features (SWF) — Veneto, Rovigo, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Rovigo_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Rovigo · 2025",
        description: "Small Woody Features (SWF) — Veneto, Rovigo, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Treviso_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Treviso · 2024",
        description: "Small Woody Features (SWF) — Veneto, Treviso, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Treviso_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Treviso · 2025",
        description: "Small Woody Features (SWF) — Veneto, Treviso, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Venezia_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Venezia · 2024",
        description: "Small Woody Features (SWF) — Veneto, Venezia, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Venezia_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Venezia · 2025",
        description: "Small Woody Features (SWF) — Veneto, Venezia, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Verona_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Verona · 2024",
        description: "Small Woody Features (SWF) — Veneto, Verona, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Verona_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Verona · 2025",
        description: "Small Woody Features (SWF) — Veneto, Verona, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Vicenza_2024",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Vicenza · 2024",
        description: "Small Woody Features (SWF) — Veneto, Vicenza, year 2024. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    },
    {
      workspace: "ESAPALWS",
      layer: "SWF_Veneto_Vicenza_2025",
      version: "1.3.0",
      metadata: {
        title: "Veneto · Vicenza · 2025",
        description: "Small Woody Features (SWF) — Veneto, Vicenza, year 2025. Vector layer: woody features classified as linear, patchy or riparian, with surface area, region/province and Sentinel-2 tile attributes.",
        downloadTypes: ["WFS"]
      }
    }
  ],

  wpsPlugin: {
    serviceUrl: "https://geoserver.esairide.tddev.it/geoserver/ows?service=WPS",
    xmlConfig: `<?xml version="1.0" encoding="UTF-8"?>
    <wps:Execute version="1.0.0" 
      service="WPS" 
      xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" 
      xmlns="http://www.opengis.net/wps/1.0.0" 
      xmlns:wfs="http://www.opengis.net/wfs" 
      xmlns:wps="http://www.opengis.net/wps/1.0.0" 
      xmlns:ows="http://www.opengis.net/ows/1.1" 
      xmlns:gml="http://www.opengis.net/gml" 
      xmlns:ogc="http://www.opengis.net/ogc" 
      xmlns:wcs="http://www.opengis.net/wcs/1.1.1" 
      xmlns:xlink="http://www.w3.org/1999/xlink" 
      xsi:schemaLocation="http://www.opengis.net/wps/1.0.0 http://schemas.opengis.net/wps/1.0.0/wpsAll.xsd">
      <ows:Identifier>gs:Download</ows:Identifier>
      <wps:DataInputs>
      <wps:Input>
        <ows:Identifier>layerName</ows:Identifier>
        <wps:Data>
        <wps:LiteralData>{WORKSPACE}:{LAYERS}</wps:LiteralData>
        </wps:Data>
      </wps:Input>
      <wps:Input>
        <ows:Identifier>outputFormat</ows:Identifier>
        <wps:Data>
        <wps:LiteralData>{downloadType}</wps:LiteralData>
        </wps:Data>
      </wps:Input>
      </wps:DataInputs>
      <wps:ResponseForm>
      <wps:RawDataOutput mimeType="image/tiff">
        <ows:Identifier>result</ows:Identifier>
      </wps:RawDataOutput>
      </wps:ResponseForm>
   </wps:Execute>`
  }
}


export async function loadSettings() {
  let response = null;
  try {
    response = await axios.get("./settings.custom.json");
    Object.assign(settings, response.data);
  } catch (e) {  console.error(e) }

  if (!response)
    try {
      response = await axios.get("./settings.json");
      Object.assign(settings, response.data);
    } catch (e) {  console.error(e) }

  try {
    if (PRODUCTION !== undefined && PRODUCTION) {
      console.error("NO CONFIGURATION FOUND !!", "please provide settings.json or settings.custom.json file !")
    }
  } catch { }
}



export default settings
